import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollReveal from "@/components/ScrollReveal";
import Landing from "@/components/Landing";
import Pricing from "@/components/Pricing";
import OperaMindWeb from "@/components/OperaMindWeb";
import Privacy from "@/components/legal/Privacy";
import Terms from "@/components/legal/Terms";
import Login from "@/components/auth/Login";
import Register from "@/components/auth/Register";
import VerifyEmail from "@/components/auth/VerifyEmail";
import ForgotPassword from "@/components/auth/ForgotPassword";
import ResetPassword from "@/components/auth/ResetPassword";
import Onboarding from "@/components/onboarding/Onboarding";
import BillingReturn from "@/components/billing/BillingReturn";
import DoneForYou from "@/components/onboarding/DoneForYou";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import StaffPortal from "@/components/staff/StaffPortal";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminLayout, { AdminProtected } from "@/components/admin/AdminLayout";
import AdminOverview from "@/components/admin/AdminOverview";
import AdminCustomers from "@/components/admin/AdminCustomers";
import AdminCustomerProfile from "@/components/admin/AdminCustomerProfile";
import AdminDFY from "@/components/admin/AdminDFY";
import AdminBilling from "@/components/admin/AdminBilling";
import AdminAI from "@/components/admin/AdminAI";
import AdminAnalytics from "@/components/admin/AdminAnalytics";
import AdminSupport from "@/components/admin/AdminSupport";
import AdminSubscriptions from "@/components/admin/AdminSubscriptions";
import AdminPhoneNumbers from "@/components/admin/AdminPhoneNumbers";
import AdminTwilioNumbers from "@/components/admin/AdminTwilioNumbers";
import AdminSquareWebhook from "@/components/admin/AdminSquareWebhook";
import AdminAnnouncements from "@/components/admin/AdminAnnouncements";
import AdminAuditLogs from "@/components/admin/AdminAuditLogs";
import AdminEmail from "@/components/admin/AdminEmail";
import PersonalLanding from "@/pa/PersonalLanding";
import PAOnboarding from "@/pa/PAOnboarding";
import PADashboard from "@/pa/PADashboard";
import ActionPage from "@/components/public/ActionPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollReveal />
        <AuthProvider>
          <AdminAuthProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/web" element={<OperaMindWeb />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/personal" element={<PersonalLanding />} />
              <Route path="/action/:token" element={<ActionPage />} />
              <Route path="/pa/onboarding" element={<ProtectedRoute product="personal"><PAOnboarding /></ProtectedRoute>} />
              <Route path="/pa" element={<ProtectedRoute product="personal"><PADashboard /></ProtectedRoute>} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
              <Route path="/onboarding/done-for-you" element={<ProtectedRoute><DoneForYou /></ProtectedRoute>} />
              <Route path="/billing/return" element={<ProtectedRoute><BillingReturn /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute product="business"><DashboardLayout /></ProtectedRoute>} />
              <Route path="/dashboard/:view" element={<ProtectedRoute product="business"><DashboardLayout /></ProtectedRoute>} />
              <Route path="/staff-portal" element={<ProtectedRoute><StaffPortal /></ProtectedRoute>} />

              {/* Admin Portal */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminProtected><AdminLayout /></AdminProtected>}>
                <Route index element={<AdminOverview />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="customers/:uid" element={<AdminCustomerProfile />} />
                <Route path="subscriptions" element={<AdminSubscriptions />} />
                <Route path="phone-numbers" element={<AdminPhoneNumbers />} />
                <Route path="twilio-numbers" element={<AdminTwilioNumbers />} />
                <Route path="square-webhook" element={<AdminSquareWebhook />} />
                <Route path="dfy" element={<AdminDFY />} />
                <Route path="billing" element={<AdminBilling />} />
                <Route path="ai" element={<AdminAI />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="announcements" element={<AdminAnnouncements />} />
                <Route path="email" element={<AdminEmail />} />
                <Route path="support" element={<AdminSupport />} />
                <Route path="audit" element={<AdminAuditLogs />} />
              </Route>
            </Routes>
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
